import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Horse_show } from '../models/horse_show';
import { Horse_show_entry } from '../models/horse_show_entry';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class PublicRecordsService {

  constructor(private http: HttpClient) { }

  public getHorseShow(id: string): Promise<Horse_show> {

	    return new Promise((resolve, reject) => {
	      return this.http.get(AppSettings.API_ENDPOINT + 'access_public/horse_shows_public/id/' + id).subscribe((response:any) => {
	        if(response.type == 'horse_show' && response.data){
	          resolve(response.data);
	        } else {
	          reject(response);
	        }

	      },
	        error_response => {
	              if(error_response instanceof HttpErrorResponse){
	                reject(error_response.error);
	              }
	              reject(error_response);
	        });
	    });
  }

  public getHorseShowEntry(id: string): Promise<Horse_show_entry> {
	    return new Promise((resolve, reject) => {
	      return this.http.get(AppSettings.API_ENDPOINT + 'access_public/horse_show_entries_public/id/' + id).subscribe((response:any) => {
	        if(response.type == 'horse_show_entry' && response.data){
	          resolve(response.data);
	        } else {
	          reject(response);
	        }

	      },
	        error_response => {
	              if(error_response instanceof HttpErrorResponse){
	                reject(error_response.error);
	              }
	              reject(error_response);
	        });
	    });
  }

}
